import MockFactory from "./MockFactory";

const Api = {

    pingFlow: (requester) => {
        let params = new URLSearchParams();
        params.append("requester", requester);

        return MockFactory.get('/flow/api/v1/healthcheck/ping', { params: params })
            .then((response) => Promise.resolve(response.status))
            .catch((error) => Promise.reject(error));
    }
};

export default Api;
